import Layout from 'layouts/error';
import Image from 'next/image';
import type { NextPage } from 'next';

const Custom404: NextPage = () => {
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center text-center max-w-320px mx-auto">
        <Image src={'/assets/images/error-404.svg'} width={263} height={128} alt="404 Image" />
        <h1 className="font-black text-dark_willow text-size16 leading-21px mt-6 mb-2">
          Yah, halaman tidak ketemu
        </h1>
        <p className="text-tarnished_silver md:text-size14 md:leading-22px text-size12 leading-19px">
          Coba cek lagi ejaan alamat yang kamu tuju, ya.
        </p>
      </div>
    </Layout>
  );
};

export default Custom404;
